var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 py-1"},[_c('span',{staticClass:"font-medium"},[_vm._v(_vm._s(_vm.item.make_text))]),_vm._v(" "+_vm._s(_vm.item.model_text)),_c('br'),_c('span',{staticClass:"font-light"},[_vm._v(_vm._s(_vm.item.version))])])}
var staticRenderFns = []

export { render, staticRenderFns }